
import { defineComponent } from "vue";
import { Content } from "@/generic";
import ClientUserGroupList from "@/client/components/settings/clientUserGroup/List.vue";
import UserName from "@/shared/components/CurrentUserName.vue";

export default defineComponent({
  components: {
    Content,
    ClientUserGroupList,
    UserName,
  },
});
